import { addToGlobalThisRet } from "@plugins";

class TabsSwitcher {
    constructor(element) {
        this.element = element;
        this.triggers = this.element.querySelectorAll("[data-trigger]");
        this.targets = this.element.querySelectorAll("[data-tab-target]");

        this._init();
    }

    _init() {
        const firstTab = this.element.querySelector("[data-trigger]");

        if (firstTab.dataset.trigger !== "all") {
            this._chooseActiveBlock(firstTab.dataset.trigger);
        }

        this._setActiveTab(firstTab);
        this._initListeners();
    }

    _setActiveTab(target) {
        if (this.triggers) {
            this.triggers.forEach((element) => {
                element.classList.remove("active");
            });

            target.classList.add("active");
        }
    }

    _chooseActiveBlock(trigger) {
        if (this.targets) {
            this.targets.forEach((target) => {
                if (trigger !== "all") {
                    target.style.display = "none";

                    if (target.dataset.tabTarget === trigger) {
                        target.removeAttribute("style");
                    }
                } else {
                    target.removeAttribute("style");
                }
            });
        }
    }

    _initListeners() {
        if (this.triggers) {
            this.triggers.forEach((tab) => {
                tab.addEventListener("click", () => {
                    this._setActiveTab(tab);
                    this._chooseActiveBlock(tab.dataset.trigger);
                });
            });
        }
    }
}

function initTabsSwitcher(target) {
    const wraps = document.querySelectorAll(`.${target || "js-tabs-triggers-init"}`);

    if (wraps) {
        wraps.forEach((tabsWrap) => {
            new TabsSwitcher(tabsWrap);
        });
    }
}

window.addEventListener("load", initTabsSwitcher());

addToGlobalThisRet(initTabsSwitcher, "initTabsSwitcher");
